import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2.667 8 6 11.334l6.667-6.667" />
  </svg>
);
export default SvgCheckmark;
